import { engineClass, type EngineClass } from "$lib/utils/engineClass";
import { recordTelemetryEvent } from "$lib/telemetry/telemetry";
import { logger } from "$lib/utils/logger";

// MAD cohorts reboot in a synchronized herd and saturate central (#327). Exclude
// vision-capable engines (electron, blink = MAD OS) — their config can't wait.
const JITTER_STARTUP_ENGINES: EngineClass[] = ["wpe", "blink-legacy"];

const STARTUP_JITTER_MS =
  Number(import.meta.env.VITE_STARTUP_JITTER_MS) || 3 * 60 * 1000; // 3 minutes

function startupJitterMs(engine: EngineClass = engineClass): number {
  if (!JITTER_STARTUP_ENGINES.includes(engine)) return 0;
  return Math.random() * STARTUP_JITTER_MS;
}

function awaitStartupJitter(engine: EngineClass = engineClass): Promise<void> {
  const delay = startupJitterMs(engine);
  if (delay > 0) {
    logger.info(
      `[StartupJitter] Delaying boot by ${Math.round(delay / 1000)}s to spread the fleet reboot herd.`
    );
    recordTelemetryEvent({
      name: "frontend_startup_jitter_ms",
      metricType: "histogram",
      value: delay,
      omitDisplayId: true,
    });
  }
  return new Promise((resolve) => setTimeout(resolve, delay));
}

export { startupJitterMs, awaitStartupJitter };
